import { useEffect, useState } from "react";
import { api, asList } from "../../lib/api";
import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { Logo } from "../../components/Logo";
import { useAuth } from "../../context/AuthContext";
import { ContentManager } from "./ContentManager";
import { Enquiries } from "./Enquiries";

const TABS = [
  ["products", "Products"],
  ["services", "Consulting"],
  ["articles", "Insights & news"],
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setUnread(asList(r.data).filter((x) => !x.read).length)).catch(() => {});
  }, []);
  return (
    <div data-testid="admin-dashboard" className="min-h-screen bg-paper">
      <header className="bg-teal text-mist">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <Link to="/" aria-label="Home"><Logo /></Link>
          <div className="flex items-center gap-2">
            <Link to="/" target="_blank" data-testid="admin-view-site" className="hidden items-center gap-2 rounded-full border border-mist/30 px-4 py-2 text-xs hover:bg-mist/10 sm:inline-flex">
              <ExternalLink className="h-3.5 w-3.5" /> View site
            </Link>
            <button onClick={logout} data-testid="admin-logout-btn" className="inline-flex items-center gap-2 rounded-full bg-mist px-4 py-2 text-xs text-teal hover:bg-sage">
              <LogOut className="h-3.5 w-3.5" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10">
        <p className="label-caps text-moss">Content studio</p>
        <h1 className="mt-3 font-display text-3xl text-teal">Kia ora, {user?.name?.split(" ")[0] || "there"}</h1>
        <p className="mt-2 text-sm text-teal/80">Write, edit and upload content. Changes appear on the website straight away.</p>
        <Tabs defaultValue="products" className="mt-10">
          <TabsList className="h-auto flex-wrap justify-start gap-1 bg-mist p-1">
            {TABS.map(([k, l]) => (
              <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`} className="rounded-full px-4 py-2 data-[state=active]:bg-teal data-[state=active]:text-mist">{l}</TabsTrigger>
            ))}
            <TabsTrigger value="enquiries" data-testid="admin-tab-enquiries" className="rounded-full px-4 py-2 data-[state=active]:bg-teal data-[state=active]:text-mist">
              Enquiries {unread > 0 && <span className="ml-2 rounded-full bg-sage px-1.5 text-[10px] text-teal-ink" data-testid="unread-count">{unread}</span>}
            </TabsTrigger>
          </TabsList>
          {TABS.map(([k]) => (
            <TabsContent key={k} value={k} className="mt-8">
              <ContentManager schemaKey={k} />
            </TabsContent>
          ))}
          <TabsContent value="enquiries" className="mt-8">
            <Enquiries onCount={setUnread} />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
